export class AvatarUtils {
  static getInitialsWithColor(firstname: string, lastname: string) {
    const initials = `${firstname?.charAt(0) || ''}${lastname?.charAt(0) || ''}`.toUpperCase();  
    // Predefined color palette
    const colors = ['#B3E4E1', '#4DC3BD', '#80D4CF', '#18978F'];
    const bgColor = colors[Math.floor(Math.random() * colors.length)];  
    // return { initials, bgColor };
    return `
    <div style="display: flex;">
        <div class="profile-pic" style="background-color: ${bgColor}; width: 30px; height: 30px; 
      border-radius: 50%; display: flex; align-items: center; justify-content: center; 
      font-weight: bold; color: white; font-size: 14px;margin-top: 5px;">
          ${ initials}
          </div>&nbsp;&nbsp;
          <span *ngIf='showFirstORLastName' style="color:black">${firstname} ${lastname}</span>
    </div>
    `;
  }

    static getInitialsWithColorForBar(firstname: string, lastname: string, showFirstORLastName:boolean=true) {
      const initials = `${firstname?.charAt(0) || ''}${lastname?.charAt(0) || ''}`.toUpperCase();  
      const colors = ['#B3E4E1', '#4DC3BD', '#80D4CF', '#18978F'];
      const bgColor = colors[Math.floor(Math.random() * colors.length)];  
      
      let html = `
    <div >
      <div class="rounded-circle me-lg-2 d-flex" style="background-color: ${bgColor}; width: 40px !important; height: 40px; 
         display: flex; align-items: center; justify-content: center; 
        font-weight: bold; color: white; font-size: 14px; margin-top: 5px;">
        ${initials}
      </div>
    `;
      if (showFirstORLastName) {
        html += `&nbsp;<span style="color: black;">${firstname} ${lastname}</span>`;
      }
      html += `</div>`;

      return html;
    }
}